<!------------------------------------------------card content-------------------------->
<div class="verifyemail-page">
  <mat-card class="mat-elevation-z12">
    <br>
      <mat-error class="service-errors">{{serviceError}}</mat-error>
      <mat-card-content>
        <form>
          @if (successMsg) {
            <div id="success" class="text-center">
              <span>{{successMsg}}</span>
            </div>
          }
          @if (errorMsg) {
            <div id="error" class="text-center">
              <span>{{errorMsg}}</span>
            </div>
          }
          @if (isLoading) {
            <div id="loading" class="text-center">
              <span>Verifying your email...</span>
            </div>
          }
          @if (!isLoading && !successMsg && !errorMsg) {
            <div id="verification-status" class="text-center">
              <mat-icon class="status-icon" [ngClass]="statusClass">{{statusIcon}}</mat-icon>
              <h3>{{statusTitle}}</h3>
              <p>{{statusMessage}}</p>
            </div>
          }
        </form>
      </mat-card-content>
    </mat-card>
  </div>
  <!-------------------------------------------------end card content---------------------->